module.exports = __webpack_public_path__ + "img/diap-1-2.93ccc047.svg";